<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" lg="12">
        <div class="card">
          <div class="card-header">
            <h5 class="float-left">Overview<b-badge variant="primary" class="ml-2">{{ currentMonth }}</b-badge></h5>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="12" class="mb-2">
                <div id="progressive-bar">
                  <div id="inner-div"></div>
                </div>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="4">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="icon-people bg-primary p-3 font-2xl mr-3 float-left"></i>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <span v-else class="estimate-val text-muted font-weight-bold">{{ members || 0 }}</span>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Active Players</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="4">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="icon-people bg-primary p-3 font-2xl mr-3 float-left"></i>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <span v-else class="estimate-val text-muted font-weight-bold">{{ newMembers || 0 }}</span>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">New Signups</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col sm="6" md="6" lg="4" xl="4">
                <b-card :no-body="true">
                  <b-card-body class="p-3 clearfix">
                    <i class="icon-people bg-primary p-3 font-2xl mr-3 float-left"></i>
                    <template v-if="fetching">
                      <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                    </template>
                    <span v-else class="estimate-val text-muted font-weight-bold">{{ totalMembers || 0 }}</span>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Total Members</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <template v-if="this.ACCOUNT_TYPE === 1">
                <b-col sm="6" md="6" lg="4" xl="4">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <i class="icon-briefcase bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <template v-if="fetching">
                        <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                      </template>
                      <span v-else class="estimate-val text-muted font-weight-bold">{{ money(turnover) || 0 }}</span>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Turnover</div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col sm="6" md="6" lg="4" xl="4">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <i class="icon-wallet bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <template v-if="fetching">
                        <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                      </template>
                      <span v-else class="estimate-val text-muted font-weight-bold">{{ money(revenue) || 0 }}</span>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Revenue from Members</div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <template v-if="showDashboardCard">
                  <b-col sm="6" md="6" lg="4" xl="4">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="icon-calculator bg-danger p-3 font-2xl mr-3 float-left"></i>
                        <template v-if="fetching">
                          <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                        </template>
                        <span v-else class="estimate-val text-muted font-weight-bold">{{ money(carried) || 0 }}</span>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Carried Negative Revenue</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </template>
                <template v-if="showDashboardCard">
                  <b-col sm="6" md="6" lg="4" xl="4">
                    <b-card :no-body="true">
                      <b-card-body class="p-3 clearfix">
                        <i class="icon-calculator bg-primary p-3 font-2xl mr-3 float-left"></i>
                        <template v-if="fetching">
                          <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                        </template>
                        <span v-else class="estimate-val text-muted font-weight-bold">{{ money(earning) || 0 }}</span>
                        <div class="text-muted text-uppercase font-weight-bold font-xs">Estimate Earning</div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </template>
                <b-col sm="6" md="6" lg="4" xl="4">
                  <b-card :no-body="true">
                    <b-card-body class="p-3 clearfix">
                      <i class="icon-briefcase bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <template v-if="fetching">
                        <span class="text-muted font-weight-bold mb-0 mt-2">Loading...</span>
                      </template>
                      <span v-else class="estimate-val text-muted font-weight-bold">{{ money(promotion) || 0 }}</span>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Promotion</div>
                    </b-card-body>
                  </b-card>
                </b-col>
              </template>
            </b-row>
          </div>
        </div>
      </b-col>
      <template v-if="this.ACCOUNT_TYPE === 1">
        <b-col cols="12" lg="12">
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col sm="12" md="12">
                  <b-card no-body>
                    <b-card-header>
                      <h3 class="float-left">Information</h3>
                    </b-card-header>
                    <b-card-body>
                      <b-table responsive="sm" :items="items" :fields="fields" :busy="fetchingSettingDetail" >
                        <template #table-busy>
                          <div class="text-center my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          {{ data.index+1 }}
                        </template>
                        <template v-slot:cell(members)="data">
                          {{ data.item.members }}+
                        </template>
                        <template v-slot:cell(revenue)="data">
                          {{ SETTING['currency'] }} {{ money(data.item.minRevenue * setting.conversionRate) }} - {{ data.item.maxRevenue > 0 ? money(data.item.maxRevenue * setting.conversionRate) : '' }}
                        </template>
                        <template v-slot:cell(rate)="data">
                          {{ data.item.rate * 100 }}%
                        </template>
                      </b-table>
                      <template v-if="commissionCalculationInfo !== ''">
                        <b-card>
                          <div v-html="commissionCalculationInfo"></div>
                        </b-card>
                      </template>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>

import moment from 'moment-timezone'
import money from '../../helper/money'

export default {
  name: 'dashboard',
  data: () => {
    return {
      agentCode: '',
      today: moment(),
      currentMonth: moment(this.today).format('MMMM') + ' ' + moment(this.today).format('YYYY'),
      dateFormat: 'YYYY-MM-DD',
      startDate: moment(this.today).startOf('month'),
      endDate: moment(this.today),
      fetching: false,
      fetchingSettingDetail: false,
      setting: '',
      carried: 0,
      earning: 0,
      members: 0,
      promotion: 0,
      revenue: 0,
      turnover: 0,
      totalMembers: 0,
      newMembers: 0,
      items: [],
      fields: [
        { key: 'index', label: 'Level' },
        { key: 'members', label: 'Members' },
        { key: 'revenue', label: 'Net Revenue from Members' },
        { key: 'rate', label: 'Net Sharing Revenue' }
      ],
      timer: 4000 * 60,
      commissionCalculationInfo: ''
    }
  },
  computed: {
    showDashboardCard () {
      const project = this.SETTING.product
      if (project === 'Betvisa') {
        return false
      }
      return true
    }
  },
  mounted () {
    Promise.all([
      this.getRevenueEstimate(),
      this.getAffiliateSettingDetail(),
      this.startTimer(),
      this.progressBar()
    ])
  },
  methods: {
    money,
    checkAccessPrivilege (module) {
      if (!module) return true
      return this.PRIVILEGE.includes(module)
    },
    async getRevenueEstimate () {
      try {
        this.fetching = true
        this.today = moment()
        if (window.sessionStorage.getItem('client')) {
          const user = JSON.parse(window.sessionStorage.getItem('client'))
          this.agentCode = user.code
        }
        const { data } = await this.$http.post(this.API_ENDPOINT + '/api/v1/agent/revenue/estimate/data', { start: moment(this.startDate).format(this.dateFormat), end: moment(this.endDate).format(this.dateFormat), agentCode: this.agentCode, index: 0 }, {headers: { 'Content-Type': 'application/json' }})
        setTimeout(() => {
          this.members = data.members
          this.earning = data.earning
          this.carried = data.carried
          this.promotion = data.promotion
          this.revenue = data.revenue
          this.turnover = data.turnover
          this.totalMembers = data.totalMembers
          this.newMembers = data.newMembers
        }, 200)
      } catch (err) {
        console.log('fetching revenue estimate error: ', err)
      } finally {
        this.fetching = false
      }
    },
    async getAffiliateSettingDetail () {
      try {
        this.fetchingSettingDetail = false
        const { data: { commission, setting } } = await this.$http.get(this.API_ENDPOINT + '/api/v1/agent/setting/getList', {headers: { 'Content-Type': 'application/json' }})
        this.items = commission.level
        this.setting = setting.currency
        this.commissionCalculationInfo = commission.calculationInfo
      } catch (err) {
        console.log('fetching affiliate setting detail error: ', err)
      } finally {
        this.fetchingSettingDetail = false
      }
    },
    startTimer () {
      const a = this
      setInterval(function () {
        document.querySelector('#inner-div').remove()
        document.querySelector('#progressive-bar').innerHTML = '<div id="inner-div"></div>'
        a.progressBar()
        a.getRevenueEstimate()
      }, a.timer)
    },
    progressBar () {
      document.querySelector('#inner-div').animate([
        {'width': '0'}
      ], {
        duration: this.timer
      })
    }
  }
}
</script>

<style>
#progressive-bar {
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 5px;
  border: 1px solid #dfdfdf
}
#inner-div {
  background: #20a8d8;
  height: 10px;
  width: 100%;
}
.estimate-val {
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue